import React from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';
import { FormGroupLabel } from '../FormGroupLabel';
registerLocale('ru', ru);
var Datepicker = function (_a) {
    var size = _a.size, className = _a.className, onChange = _a.onChange, disabled = _a.disabled, maxDate = _a.maxDate, minDate = _a.minDate, value = _a.value, label = _a.label, name = _a.name, id = _a.id, isRounded = _a.isRounded, required = _a.required, placeholder = _a.placeholder, yearDropdownItemNumber = _a.yearDropdownItemNumber, dateFormat = _a.dateFormat, showTimeSelect = _a.showTimeSelect, showTimeSelectOnly = _a.showTimeSelectOnly, timeIntervals = _a.timeIntervals, maxTime = _a.maxTime, minTime = _a.minTime, onKeyDown = _a.onKeyDown, filterDate = _a.filterDate, filterTime = _a.filterTime, excludeDates = _a.excludeDates, excludeTimes = _a.excludeTimes, includeDates = _a.includeDates, includeTimes = _a.includeTimes, helpText = _a.helpText, isDisabledKeyboard = _a.isDisabledKeyboard, feedback = _a.feedback, isClearable = _a.isClearable, saveLSKeyId = _a.saveLSKeyId;
    var isDateAndTime = showTimeSelect && !showTimeSelectOnly;
    var getMaxDate = function (newMaxDate) {
        if (newMaxDate) {
            return newMaxDate;
        }
        else {
            var date = new Date();
            return new Date(date.setMonth(date.getMonth() + 12));
        }
    };
    var getInputPadding = function () {
        switch (size) {
            case 'sm':
                return 'sm ';
            default:
                return 'lg ';
        }
    };
    var localOnChange = function (date) {
        if (saveLSKeyId && date) {
            localStorage.setItem(saveLSKeyId, JSON.stringify(date));
            onChange(date);
        }
        else {
            onChange(date);
        }
    };
    var getValue = function () {
        if (saveLSKeyId) {
            var savedValue = JSON.parse(localStorage.getItem(saveLSKeyId));
            if (savedValue) {
                value = savedValue;
            }
        }
        if (value === 0 || value === null || value === undefined) {
            value = null;
        }
        else {
            value = new Date(value);
        }
        return value;
    };
    return (React.createElement(FormGroupLabel, { feedback: feedback, isRounded: isRounded, label: label, className: className, isRequired: required, helpText: helpText },
        React.createElement(ReactDatePicker, { clearButtonTitle: 'Очистить', isClearable: isClearable, disabledKeyboardNavigation: isDisabledKeyboard, id: id, name: name, selected: getValue(), dateFormat: dateFormat ? dateFormat : 'dd.MM.yyyy', required: required, disabled: disabled, showMonthDropdown: true, showYearDropdown: true, showTimeSelect: showTimeSelect ? showTimeSelect : false, showTimeSelectOnly: showTimeSelectOnly ? showTimeSelectOnly : false, timeIntervals: timeIntervals, showPopperArrow: false, locale: 'ru', popperClassName: 'date-picker-popper ' + (isDateAndTime ? 'react-datepicker-date-time ' : ''), wrapperClassName: 'date-picker-wrapper ' +
                (isRounded ? 'round ' : '') +
                (size === 'sm' ? 'date-sm ' : 'date-lg '), className: 'gr-input ac-w-100 outline-none ' + getInputPadding() + (isRounded ? 'round ' : ''), placeholderText: placeholder, onInputClick: function () { }, autoComplete: 'off', dropdownMode: 'scroll', scrollableYearDropdown: true, yearDropdownItemNumber: yearDropdownItemNumber ? yearDropdownItemNumber : 50, minDate: minDate, maxDate: getMaxDate(maxDate), minTime: minTime ? minTime : null, maxTime: maxTime ? maxTime : null, onChange: function (date) {
                localOnChange(date);
            }, onKeyDown: onKeyDown
                ? function (e) {
                    onKeyDown(e);
                }
                : function () { }, filterDate: filterDate, 
            // @ts-ignore
            filterTime: filterTime, excludeDates: excludeDates, excludeTimes: excludeTimes, includeDates: includeDates, includeTimes: includeTimes })));
};
export { Datepicker };
//# sourceMappingURL=Datepicker.js.map